export default __webpack_public_path__ + "static/media/empty-cart.56408672.jpg";